// Две кнопки для отрендеренного PDF задания печати: «Открыть» (в новой
// вкладке) и «Скачать».  Обе идут через printApi.fetchJobPdf — чтобы
// прикрепился bearer-токен (обычный <a href> упал бы в 401, браузер не
// шлёт Authorization при клике по ссылке).
//
// Общий компонент: используется и на главной странице печати, и в диалоге
// печати QR (станции/рулоны).  Так «скачать PDF вместо печати» одинаково
// доступно во всех диалогах — экономим бумагу, не гоним всё на принтер.

import { useEffect, useRef, useState } from "react";

import { printApi } from "@/lib/api";

export function PdfActions({
  jobId,
  autoDownload = false,
}: {
  jobId: string;
  autoDownload?: boolean;
}) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [pending, setPending] = useState<"open" | "download" | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const autoRan = useRef(false);

  useEffect(() => {
    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [blobUrl]);

  // «Сохранить в PDF»: как только рендер готов — отдаём файл в браузер
  // автоматически (оператор выбрал «сохранить», а не «печатать»).  Ровно один раз.
  useEffect(() => {
    if (autoDownload && !autoRan.current) {
      autoRan.current = true;
      void onDownload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoDownload]);

  const obtainUrl = async (): Promise<string> => {
    if (blobUrl) return blobUrl;
    const blob = await printApi.fetchJobPdf(jobId);
    const url = URL.createObjectURL(blob);
    setBlobUrl(url);
    return url;
  };

  const onOpen = async () => {
    setErr(null);
    setPending("open");
    try {
      const url = await obtainUrl();
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Не удалось открыть PDF");
    } finally {
      setPending(null);
    }
  };

  const onDownload = async () => {
    setErr(null);
    setPending("download");
    try {
      const url = await obtainUrl();
      const a = document.createElement("a");
      a.href = url;
      a.download = `job-${jobId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Не удалось скачать PDF");
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" className="btn" onClick={onOpen} disabled={pending !== null}>
        {pending === "open" ? "Открытие…" : "👁 Открыть PDF"}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={onDownload}
        disabled={pending !== null}
      >
        {pending === "download" ? "Скачивание…" : "⬇ Скачать PDF"}
      </button>
      {err && <span className="text-state-danger text-xs">{err}</span>}
    </div>
  );
}
